import { Adapter as y, getAdapter as t } from "../../../../adapter.js";
import { AdyenPaymentMethodModel as o } from "./adyenPaymentMethod.model.js";
import { AdyenGPayPaymentMethodAdapter as n } from "./adyenGPayPaymentMethod/adyenGPayPaymentMethod.adapter.js";
import { AdyenApplePayPaymentMethodAdapter as a } from "./adyenApplePayPaymentMethod/adyenApplePayPaymentMethod.adapter.js";
import { AdyenGPayPaymentMethod as d } from "./adyenGPayPaymentMethod/adyenGPayPaymentMethod.model.js";
import { AdyenApplePaymentMethod as i } from "./adyenApplePayPaymentMethod/adyenApplePayPaymentMethod.model.js";
class h extends y {
  adapt(e) {
    const r = t(n), p = t(a);
    return e.type === "googlepay" ? r.adapt(e) : e.type === "applepay" ? p.adapt(e) : new o({
      brands: e.brands,
      name: e.name,
      type: e.type
    });
  }
  serialize(e) {
    const r = t(n), p = t(a);
    return e instanceof d ? r.serialize(e) : e instanceof i ? p.serialize(e) : {
      brands: e.brands,
      name: e.name,
      type: e.type
    };
  }
}
export {
  h as AdyenPaymentMethodAdapter
};
//# sourceMappingURL=adyenPaymentMethod.adapter.js.map
